import { FC, ReactElement, useRef } from 'react';

import { Icon } from '@pp/core/src/components/icons/icon';
import { Icons } from '@pp/core/src/components/icons/iconNames';
import { useAudioTrigger } from '@pp/core/src/controllers/audioController/hooks';
import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';

import { RecentResultsItemType } from '../../../api/recentResults';
import { useGameDispatch } from '../../../store/GameStore';
import { useHighflyerGameStateSlice } from '../../../store/slices/highflyerGame/selectors';
import { useRecentResultDetailStateSlice } from '../../../store/slices/recentResultDetail/selectors';
import { recentResultDetailStateActions } from '../../../store/slices/recentResultDetail/slice';
import { Copied } from '../copied/Copied';

import { CopyToClipboard } from './CopyToClipboard';

import styles from './ValueContainer.module.css';

export interface ModalResultProp {
  index: number;
}

export const ModalResult: FC<ModalResultProp> = ({ index }): ReactElement => {
  const result = useRef('');
  const dispatch = useGameDispatch();
  const audioTrigger = useAudioTrigger();
  const copied = useRecentResultDetailStateSlice.getCopied();
  const hashKey = useRecentResultDetailStateSlice.getHashKey();
  const clickedTab = useRecentResultDetailStateSlice.getHashModalData().clickedTab;
  const totalResults: number = useHighflyerGameStateSlice.recentResultsCount();

  let details: RecentResultsItemType | undefined;

  if (clickedTab !== 'footer') {
    result.current = hashKey;
  } else if (index >= 0 && clickedTab === 'footer') {
    if (index < totalResults) {
      details = useHighflyerGameStateSlice.recentResults()?.history[index];
    }
    if (details) {
      result.current = details.gameHashKey;
    }
  }

  const copyToClipboard = (content: string) => {
    audioTrigger.play({ name: 'menuClick' });
    dispatch(recentResultDetailStateActions.setCopied(2));
    setTimeout(() => {
      dispatch(recentResultDetailStateActions.setCopied(0));
    }, 1500);
    CopyToClipboard(content);
  };

  return (
    <div className={styles.modalResult}>
      <div className={styles.modalValueName}>
        <L10nText tk={'RESULT'} />:{copied === 2 && <Copied />}
      </div>
      <div className={styles.modalValueContainer}>
        <div className={`${styles.modalValueLeft} ${index === -1 && styles.inPlayResult}`} id="modal-result">
          {index === -1 ? <L10nText tk="WAIT_TILL_END_CAPS" /> : result.current}
        </div>

        {index !== -1 && (
          <div className={styles.modalValueCopy} onClick={() => copyToClipboard(result.current)}>
            <button>
              <Icon icon={Icons.Copy} color="white" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
